import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:key',
    name: 'DynamicPage',
    component: () =>
      import(/* webpackChunkName: "page" */ '@/views/PageView.vue'),
  },
  {
    path: '*',
    beforeEnter() {
      window.location.href = process.env.VUE_APP_LANDING_PAGE_URL
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
